import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseRefi } from 'src/oldApp/model/base-refi';

@Injectable({
  providedIn: 'root'
})
export class BaseRefiService {

  private url:string;
  private headers: HttpHeaders = new HttpHeaders({ 
    'Access-Control-Allow-Origin': '*'
    , 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE'
    , 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization'  
  });


  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  getListBaseRefi=(year:string, month:string)=> {
    return this.http.get(`${this.url}/BaseRefi/ListBaseRefi?year=${year}&month=${month}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  downloadBaseRefi=(year:string, month:string)=> {
    return this.http.get(`${this.url}/BaseRefi/DownloadBaseRefi?year=${year}&month=${month}`, {responseType: 'blob'});
  }

  getListBaseRefiPaginated=(request:any)=> {
    return this.http.post(`${this.url}/BaseRefi/ListBaseRefiPaginated`, request)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  upload(file: File, userId:number, year:string, month:string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.url}/BaseRefi/upload?userId=${userId}&year=${year}&month=${month}`, formData, {
      reportProgress: true,
      responseType: 'json',
      headers: this.headers
    });

    return this.http.request(req);
  }
  
}
